export const EXTENSION_TIMEOUT_FAILURE = 'Extension timeout';
export const SCREENSHOT_NOT_SUPPORTED = 'Screenshot not supported';
export const SCREENSHOT_UPLOAD_ERROR = 'screenshot_upload_error';
export const EXTENSION_DATAURI_EMPTY = 'extension data empty';
export const screenshotServerUnavailableMessage = (error: unknown) => {
  if (error instanceof Error) {
    return `unavailable - ${error.message}`;
  }
  return 'unavailable';
};
export const WRONG_PLAN = 'wrong_plan';
export const CAPTURE_ERROR = 'screenshot_capture_error';
